import attendant from './attendant'
import general from './general'
import inspirator from './inspirator'
import pmbk from './pmbk'
import pobk from './pobk'

const classical = Object.assign({}, attendant, pmbk, pobk, inspirator,  general)

export default classical